<template>
  <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-btn
            v-for="obj in languages"
            :key="obj.id"
            rounded
            :color="$vuetify.theme.themes.light.primary"
            dark
            depressed
            :x-large="$vuetify.breakpoint.lgAndUp"
            :large="$vuetify.breakpoint.md"
            x-small
            @click="changeLanguage(obj.tag)"
            class="button"
          >
            {{ obj.language }}
          </v-btn>
        </v-col>
      </v-row>
  </v-container>
</template>

<script>
import i18n from '../i18n';
import Languages from '../utils/languages';

export default {
  name: 'Languages',
  data: () => ({
    languages: Languages,
  }),
  methods: {
    changeLanguage(language) {
      i18n.locale = language;
      this.callPage();
    },
    callPage() {
      this.$router.push({ name: 'pluris' });
    },
  },
};
</script>

<style scoped>
.button {
  font-weight: 700;
}

.v-btn:not(.v-btn--round).v-size--x-large {
  height: 40px;
}

.container--fluid {
  padding: 0;
}

.v-btn:not(.v-btn--round).v-size--small {
  height: 25px;
}

.v-btn:not(.v-btn--round).v-size--large {
  height: 30px;
}

/*
 xl - 4k and ultra-wides 1904px*

*/

@media (min-width: 1905px) {
  .button {
    font-size: 1.1rem;
    letter-spacing: 1px;
    margin-left: 30px;
    margin-right: 30px;
  }
}

/*
  lg - desktop 1264px* 1904px*
*/

@media (min-width: 1265px) and (max-width: 1904px) {
  .button {
    font-size: 1.1rem;
    letter-spacing: 1px;
    margin-left: 25px;
    margin-right: 25px;
  }
}

/*
  md - large tablet to laptop960px 1264px*
*/

@media (min-width: 961px) and (max-width: 1264px) {
  .button {
    letter-spacing: 0.8px;
    margin-left: 20px;
    margin-right: 20px;
  }
}

/*
  sm - small to medium tablet600px 960px
*/

@media (min-width: 601px) and (max-width: 960px) {
  .button {
    letter-spacing: 0.6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}

/*
  xs - small to large handset600px

*/

@media screen and (max-width: 600px) {
  .button {
    font-size: 0.6rem;
    letter-spacing: 0.4px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
